module.exports = __webpack_public_path__ + "img/cpgl1.87f29eb9.png";